<template>
  <div class="text-center">
    <v-overlay :value="showOverlay">
      <v-progress-circular
        :v-if="showSpinner"
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'SpinnerOverlay',
  components: {
  },
  props: {
    showOverlay: { type: Boolean, required: true },
    showSpinner: { type: Boolean, required: true }
  }
}
</script>
